<app-grid [data]="gridData" [columns]="gridColumns$ | async" [options]="gridOptions$ | async"></app-grid>

<ng-template #statusTemplate let-context>
  <app-chip
    *ngLet="(context.data.status | warningStatus: dprDetails.lockedDate) as warningStatus"
    [matTooltip]="warningStatus?.text"
    [icon]="warningStatus?.icon"
    [color]="warningStatus?.color"
  ></app-chip>
</ng-template>

<ng-template #durationTemplate let-context>
  <span>{{(context.data.start | duration: context.data.finish) }}</span>
</ng-template>

<ng-template #infoTemplate let-context>
  <div class="d-flex buttonsWrapper">
    <button
      *ngIf="(context.data?.dprForecastActivityCustomDataList | arrayRemoveFalsyValues : 'value')?.length"
      mat-icon-button
      color="primary"
      class="flex-initial squareIconButton"
      (click)="context.cell.actions.startEdit({selectedTab: DprForecastData.CustomData})"
    >
      <mat-icon
        matTooltip="Custom Data"
        i18n-matTooltip="@@dprDetails.dprForecastActivitiesGrid.attrCustomData"
        svgIcon="tag-multiple"
      ></mat-icon>
    </button>
    <button
      *ngIf="context.data?.dprForecastSubActivities?.length"
      mat-icon-button
      color="primary"
      class="flex-initial squareIconButton"
      (click)="context.cell.actions.startEdit({selectedTab: DprForecastData.Subactivities})"
    >
      <mat-icon
        matTooltip="Sub Activities"
        i18n-matTooltip="@@dprDetails.dprForecastActivitiesGrid.attrSubActivities"
        svgIcon="format-align-left"
      ></mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #actionsTemplate let-context>
  <button class="flex-initial button--square mat-secondary" mat-flat-button [matMenuTriggerFor]="activityActions">
    <mat-icon svgIcon="dots-horizontal"></mat-icon>
  </button>
  <mat-menu #activityActions="matMenu">
    <button mat-menu-item (click)="context.cell.actions.startEdit({selectedTab: DprForecastData.CustomData})">
      <mat-icon svgIcon="details"></mat-icon>
      <span i18n="@@dprDetails.dprActivitiesGrid.btnDetails">Details</span>
    </button>
    <button mat-menu-item *ngIf="context.row.allowDeleting" (click)="context.row.actions.delete()">
      <mat-icon svgIcon="delete-forever"></mat-icon>
      <span>{{StaticMessage.DeleteButton| staticMessage}}</span>
    </button>
  </mat-menu>
</ng-template>
